import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import AssignmentDetailContent from "./AssignementDetailContent";
import { Loading } from "components";
import { useLazyGetUserThemeByIdQuery } from "api/generated";
import { processApiError } from "utils/processApiError";

const AssignmentDetail = () => {
  const { assignmentId, themeId } = useParams();
  const [pageId, setPageId] = useState<string | undefined>(undefined);
  const navigate = useNavigate();

  if (!assignmentId) {
    navigate("/");
    return null;
  }

  const [loadTheme, { data: themeData, isLoading: isThemeLoading, error: apiThemeError }] =
    useLazyGetUserThemeByIdQuery();

  useEffect(() => {
    if (!themeId) return;

    loadTheme({ userThemeId: themeId }).catch(() => {});
  }, [themeId, loadTheme]);

  useEffect(() => {
    if (apiThemeError === undefined) return;

    processApiError(apiThemeError);
  }, [apiThemeError]);

  useEffect(() => {
    setPageId(assignmentId);
  }, [assignmentId]);

  if (!pageId || isThemeLoading) return <Loading />;

  return (
    <AssignmentDetailContent
      key={pageId}
      assignmentId={pageId}
      themeId={themeId}
      userThemeId={themeData?.userTheme.theme?.id}
    />
  );
};

export default AssignmentDetail;
